'use strict';
/**
 * Split name and email address from string
 */

var _slicedToArray = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

module.exports = function splitNameEmail(str) {
  //If no email bracket present, return as is
  if (str.indexOf('<') === -1) {
    return ['', str];
  } //Split into name and email


  var _str$split = str.split('<'),
      _str$split2 = _slicedToArray(_str$split, 2),
      name = _str$split2[0],
      email = _str$split2[1]; //Trim and fix up


  name = name.trim();
  email = email.replace('>', '').trim(); //Return as array

  return [name, email];
};